import {
  RouteRecordRaw,
} from 'vue-router';

import {
  ERouteName,
} from '@/router/route-name.ts';

export const routes: RouteRecordRaw[] = [
  {
    name: ERouteName.HOME,
    path: '/',
    component: () => import('@/page/home/home.vue'),
  },
  {
    name: ERouteName.LOGIN,
    path: '/login',
    component: () => import('@/page/login/login.vue'),
  },
  {
    name: ERouteName.LICENSE,
    path: '/license',
    component: () => import('@/page/license/license-create.vue'),
  },
  {
    name: ERouteName.PRICE_CALCULATOR_SETTINGS,
    path: '/price-calculator/settings',
    component: () => import('@/page/price-calculator/settings.vue'),
  },
  {
    name: ERouteName.COMPANIES,
    path: '/price-calculator/companies',
    component: () => import('@/page/companies/companies-overview.vue'),
  },
  {
    name: ERouteName.COMPANIES_CREATE,
    path: '/price-calculator/companies/create',
    component: () => import('@/page/companies/company-details.vue'),
  },
  {
    name: ERouteName.COMPANIES_DETAIL,
    path: '/price-calculator/companies/:companyId/:revisionId',
    component: () => import('@/page/companies/company-details.vue'),
  },
  {
    name: ERouteName.PROJECTS_DETAIL,
    path: '/price-calculator/projects/:projectId/:revisionId',
    component: () => import('@/page/projects/project-details.vue'),
  },
];
